<script lang="ts">
	let { size = 40, decorative = false } = $props<{ size?: number; decorative?: boolean }>();
</script>

<svg
	class="brand-symbol"
	width={size}
	height={size}
	viewBox="0 0 64 64"
	fill="none"
	role={decorative ? undefined : 'img'}
	aria-hidden={decorative ? 'true' : undefined}
	aria-label={decorative ? undefined : 'ANDRESOT'}
>
	<path
		d="M14 6h36c4.42 0 8 3.58 8 8v29c0 4.42-3.58 8-8 8H35.5L24 59v-8H14c-4.42 0-8-3.58-8-8V14c0-4.42 3.58-8 8-8Z"
		fill="var(--accent-primary)"
	/>
	<path
		d="m19 41 10.7-25h5.05L45.5 41h-7.1l-1.75-4.65H27.7L26 41h-7Zm11-10.6h4.35l-2.2-6.15L30 30.4Z"
		fill="var(--text-on-accent)"
	/>
	<path
		d="M24 46h17"
		stroke="var(--text-on-accent)"
		stroke-opacity=".5"
		stroke-width="2"
		stroke-linecap="round"
	/>
</svg>

<style>
	.brand-symbol {
		display: block;
		flex: none;
	}
</style>
